import "./styles.css";

import { createRoot } from "react-dom/client";
import { Info } from "./info";

const root = createRoot(document.getElementById("root")!);
root.render(<Info />);
